var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripesStraight = function SvgStripesStraight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 509,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 432,
    width: 36,
    height: 432,
    rx: 18,
    transform: "rotate(-180 36 432)",
    fill: "url(#stripes-straight_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 432,
    width: 36,
    height: 432,
    rx: 18,
    transform: "rotate(-180 161 432)",
    fill: "url(#stripes-straight_svg__b)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 432,
    width: 36,
    height: 432,
    rx: 18,
    transform: "rotate(-180 286 432)",
    fill: "url(#stripes-straight_svg__c)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 77,
    width: 37,
    height: 432,
    rx: 18.5,
    fill: "url(#stripes-straight_svg__d)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 77,
    width: 36,
    height: 432,
    rx: 18,
    fill: "url(#stripes-straight_svg__e)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-straight_svg__a",
    x1: 54,
    y1: 432,
    x2: 54,
    y2: 864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-straight_svg__b",
    x1: 179,
    y1: 432,
    x2: 179,
    y2: 864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-straight_svg__c",
    x1: 304,
    y1: 432,
    x2: 304,
    y2: 864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-straight_svg__d",
    x1: 80.5,
    y1: 77,
    x2: 80.5,
    y2: 509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-straight_svg__e",
    x1: 205,
    y1: 77,
    x2: 205,
    y2: 509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgStripesStraight;